import { render, staticRenderFns } from "./NFTPayload.vue?vue&type=template&id=4bfb4e0e&scoped=true&"
import script from "./NFTPayload.vue?vue&type=script&lang=ts&"
export * from "./NFTPayload.vue?vue&type=script&lang=ts&"
import style0 from "./NFTPayload.vue?vue&type=style&index=0&id=4bfb4e0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb4e0e",
  null
  
)

export default component.exports